const categoryListingBase = {
  categoriesQueryErrorText1: `An error occurred while loading categories, please make sure you have an internet connection, or else contact Jules at`,
  categoriesQueryErrorText2: `An error occurred while loading categories, contact Jules at`,
  categoriesQueryErrorText3: `for assistance.`,
  categoriesQueryErrorText4: `Back`,
  categoriesQueryErrorText5: `Try again`,
};

export default categoryListingBase;
